import src from "IMAGE";
export default { src, width: 259, height: 262, blurWidth: 0, blurHeight: 0};
